module.exports = require("!!vue-loader!../../node_modules/_vue-markdown-loader@2.4.1@vue-markdown-loader/lib/markdown-compiler.js?raw!./button.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/button.md
// module id = ZI7X
// module chunks = 0